// Whether the Wasm engine is unavailable and the fallback in use, as
// reactive state, so what depends on it (the diff option) follows a
// failure that happens after it is on screen.
export const degraded = $state({ value: false });
